<i2a-resource-nodata [resourceKey]="configuration.resourceKey" *ngIf="resourceProfile && displayNoData">
</i2a-resource-nodata>